import { notifications } from '@mantine/notifications';
import { logError } from './logging/error-logger';

interface NotificationOptions {
  title: string;
  message: string;
}

export function showSuccessNotification({ title, message }: NotificationOptions): void {
  notifications.show({
    title,
    message,
    color: 'green',
    autoClose: 4000,
  });
}

export function showErrorNotification({ title, message }: NotificationOptions): void {
  notifications.show({
    title,
    message,
    color: 'red',
    autoClose: 6000,
  });
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (error && typeof error === 'object') {
    if ('message' in error && typeof error.message === 'string') {
      return error.message;
    }
    logError(error, { operation: 'getErrorMessage' });
  }

  return 'An unexpected error occurred. Please try again or contact support if the problem persists.';
}
